export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const reset_password = 'Reset Password';
export const enter_otp = 'Enter OTP';
export const validation = {
  email_valid: 'Please enter valid email',
  email_require: 'Email is required',
  otp: 'OTP must be exactly 6 digits and contain only numbers',
  otp_require: 'OTP is required',
};

export const label_text = 'Email address';
export const placeholder = 'Enter Email Address';
export const otp_placeholder = 'Enter OTP';
export const cancel = 'Cancel';

export const name = {
    email : "email",
    otp : 'otp'
}
